import AllowanceReducer from "./allowance";
import AllowanceDetailReducer from "./allowance-detail";
import AttendanceReducer from "./attendance";
import CategoryEmployeeReducer from "./category";
import DailyAttendanceReducer from "./daily-attendance";
import DivisionReducer from "./divison";
import EmployeeReducer from "./employee";
import HolidayReducer from "./holiday";
import PositionReducer from "./position";
import RecapAttendanceReducer from "./recap-attendance";
import SalaryClassReducer from "./salary-class";
import SalaryCutsReducer from "./salary-cuts";
import SalaryCutsDetailReducer from "./salary-cuts-detail";
import SalaryTypeReducer from "./salary-type";

export default {
    allowance:AllowanceReducer,
    allowanceDetail:AllowanceDetailReducer,
    attendance:AttendanceReducer,
    categoryEmployee:CategoryEmployeeReducer,
    dailyAttendance:DailyAttendanceReducer,
    division:DivisionReducer,
    employee:EmployeeReducer,
    holiday:HolidayReducer,
    position:PositionReducer,
    recapAttendance:RecapAttendanceReducer,
    salaryClass:SalaryClassReducer,
    salaryCuts:SalaryCutsReducer,
    salaryCutsDetail:SalaryCutsDetailReducer,
    salaryType:SalaryTypeReducer,
}